import { Marketday } from '../marketday';
export class Boothfee {
    constructor(
        public id?: number,
        public marketdayNumber?: string,
        public validFrom?: any,
        public validMonth?: number,
        public priceType?: string,
        public priceCategoryA?: number,
        public priceCategoryB?: number,
        public priceCategoryC?: number,
        public priceCategoryD?: number,
        public minBoothFee?: number,
        public basicCharges?: number,
        public unit?: string,
        public updated?: any,
        public created?: any,
        public gguid?: string,
        public marketday?: Marketday,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/boothfee/boothfee.model.ts